_getAnonymousUserEmailPreferencesThunk